import { useRouteLoaderData } from 'react-router';
import { id as appLayoutId } from '@/layout/app-layout';
import type { Club } from '@repo/shared-types';

export function useCurrentClub() {
  const data = useRouteLoaderData(appLayoutId) as { club: Club } | undefined;
  if (!data) {
    throw new Error('useCurrentClub can only be used within app-layout routes');
  }
  return data.club;
}
